import * as CertificateReportsDataApiConstants from '../data/CertificateReportsDataApiConstants.js';

function removeDiacritics(text) {
    return text.normalize('NFD').replace(/[\u0300-\u0302&&\u0304-\u036f]/g, "").normalize('NFC');
}

async function getFacultyDocIdFromEmployeeNumber(employeeNumber){
    const bodyJSON = {
        campos: CertificateReportsDataApiConstants.FACULTY_DOCID_QUERY_FIELDS.join(','),
        idPregunta: CertificateReportsDataApiConstants.ID_PREGUNTA,
        orden: CertificateReportsDataApiConstants.DEFAULT_QUERY_ORDER + ' LIMIT 1',
        codProf: employeeNumber,
    }

    const facultyInfo = await fetchData(bodyJSON, CertificateReportsDataApiConstants.CERTIFICATE_REPORTS_API_ENDPOINT);
    if(facultyInfo.reportData && facultyInfo.reportData.length === 1){
        return facultyInfo.reportData[0].doc_identi;
    }
    return null;
}

async function getCertificateReportData(codProf, userId, userName, userFirstSurname){
    const bodyJSON = {
        campos: CertificateReportsDataApiConstants.CERTIFICATE_REPORTS_QUERY_FIELDS.join(','),
        idPregunta: CertificateReportsDataApiConstants.ID_PREGUNTA,
        orden: CertificateReportsDataApiConstants.DEFAULT_QUERY_ORDER,
        docIden: (userId && userId.trim().length > 0) ? userId.trim() : null,
        nomProf: (userName && userName.trim().length > 0) ? removeDiacritics(userName.trim()) : null,
        apesProf: (userFirstSurname && userFirstSurname.trim().length > 0) ? removeDiacritics(userFirstSurname.trim()) : null,
        codProf: (codProf && codProf.trim().length > 0) ? codProf.trim() : null
    }

    const reportData = await fetchData(bodyJSON, CertificateReportsDataApiConstants.CERTIFICATE_REPORTS_API_ENDPOINT);
    reportData.reportData.sort((a, b) => {
        if (a.cur_academ === b.cur_academ && a.desc_asignatura && b.desc_asignatura) {
          return a.desc_asignatura.localeCompare(b.desc_asignatura);
        }
        return a.cur_academ.localeCompare(b.cur_academ);
      });
    return reportData;
}

async function getFacultyReportData(codProf, userId, userName, userFirstSurname){
    const bodyJSON = {
        campos: CertificateReportsDataApiConstants.FACULTY_REPORTS_QUERY_FIELDS.join(','),
        orden: CertificateReportsDataApiConstants.FACULTY_REPORT_QUERY_ORDER,
        docIden: (userId && userId.trim().length > 0) ? userId.trim() : null,
        nomProf: (userName && userName.trim().length > 0) ? removeDiacritics(userName.trim()) : null,
        apesProf: (userFirstSurname && userFirstSurname.trim().length > 0) ? removeDiacritics(userFirstSurname.trim()) : null,
        codProf: (codProf && codProf.trim().length > 0) ? codProf.trim() : null
    }

    const reportData = await fetchData(bodyJSON, CertificateReportsDataApiConstants.CERTIFICATE_REPORTS_API_ENDPOINT);
    return reportData;
}

async function getFacultyQualitativeReportData(docId, cursoAcad, codigoAsig){
    let curso = (cursoAcad.length === 0) ? null : cursoAcad.join(',');
    let asignatura = (codigoAsig.length === 0) ? null : codigoAsig.join(',');
    const bodyJSON = {
        campos: null,
        orden: CertificateReportsDataApiConstants.FACULTY_QUALITATIVE_REPORT_QUERY_ORDER,
        docIden: (docId && docId.length > 0) ? docId.trim() : null,
        curAca: curso,
        codAsi: asignatura
    }
    const qualitativeReportData = await fetchData(bodyJSON, CertificateReportsDataApiConstants.CERTIFICATE_REPORTS_QUALITATIVE_API_ENDPOINT);
    return qualitativeReportData;
}

async function fetchData(bodyJSON, endpoint){
    try {
        const requestOptions = {
            method: CertificateReportsDataApiConstants.HTTP_POST_METHOD,
            headers: CertificateReportsDataApiConstants.HTTP_HEADERS,
            body: JSON.stringify(bodyJSON)
        };

        const response = await fetch(endpoint, requestOptions);
        if (response.ok) {
            if(endpoint === CertificateReportsDataApiConstants.CERTIFICATE_REPORTS_API_ENDPOINT){
                return parseServiceResponse(await response.json());;
            } else if(endpoint === CertificateReportsDataApiConstants.CERTIFICATE_REPORTS_QUALITATIVE_API_ENDPOINT){
                return parseQualitativeServiceResponse(await response.json());
            }
        } else {
            console.error("Hubo un error al obtener los datos del informe");
        }
    } catch (error) {
        console.error(error);
    }

    return;
}

function parseServiceResponse(response){
    response.forEach((item, index, self) => {
        if(!item.modalidad) self[index].modalidad = 'SIN MODALIDAD';
        if(!item.segmento) self[index].segmento = 'SIN SEGMENTO';
    });
    return {
        centerFilterValues: [...response.map((item) =>{
             return {
                label: item.desc_centro + ' (' + item.desc_poblacion + ')',
                value: item.desc_centro
             }
        }).filter((item, index, self) =>
            index === self.findIndex((t) => (
                t.value === item.value
            )
        ))],
        academicYearFilterValues: [...new Set(response.map((item) => item.cur_academ))],
        modalityFilterValues: [...new Set(response.map((item) => item.modalidad))],
        segmentFilterValues: [...new Set(response.map((item) => item.segmento))],
        subjectFilterValues: [...response.map((item) => {
            return {
                label: item.cod_asignatura + ' | ' +
                    item.desc_asignatura  + ' | ' +
                    item.cod_grupo_simple + ' | ' +
                    item.desc_titulacion,
                value: item.cod_asignatura + '-' + item.cod_grupo_simple
            }
        }).filter((item, index, self) =>
            index === self.findIndex((t) => (
                t.value === item.value
            )
        ))],
        facultyFilterValues: [...response.map((item) => {
            return {
                label: item.nombre + ' ' + item.apellido1  + ' ' + ((item.apellido2) ? item.apellido2 : ''),
                value: item.doc_identi
            }
        }).filter((item, index, self) =>
            index === self.findIndex((t) => (
                t.value === item.value
            )
        ))],
        reportData: response
    };
}

function parseQualitativeServiceResponse(response){
    return {
        reportData: response
    };
}

export {
    getCertificateReportData,
    getFacultyReportData,
    getFacultyDocIdFromEmployeeNumber,
    getFacultyQualitativeReportData
}